<template>
  <div>
    <form
      :ref="refFormOpenHours"
      @submit.prevent
    >
      <div class="emd-panel">
        <div class="emd-panel__section">
          <div class="emd-panel__block">
            <div class="el-chunk">
              <h2 class="emd-label _required open-hours__title">
                {{ $t('title') }}
              </h2>
              <span class="emd-text _size_small _color_nonessential">
                {{ $t('description') }}
              </span>
            </div>
          </div>
          <div class="emd-panel__block">
            <div
              v-for="[index, item] of form.entries()"
              class="emd-form-group eu-flex eu-no-margin"
              :key="item.name"
            >
              <open-hours-input
                :ref="item.name"
                :id="'id' + item.name"
                :disabled="disabled"
                :value="item"
              />
              <copy-to-all
                v-if="showCopy(item)"
                data-testid="copy-to-all"
                :item="item"
                @click="showModal(item)"
              />
            </div>
            <copy-toall-confirmation-modal
              v-if="copyToAllModalVisible"
              :show="copyToAllModalVisible"
              :item="currentDay"
              @onCancel="handleClose"
              @onCopy="handleCopyAll"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { WEEKDAYS_LIST } from '@/enums/week-days.enum'

import FORM_CONTEXT_PHYSICAL_WORLD from '../forms-context.enum.js'
import PhysicalWorldFormDTO from '../PhysicalWorldFormDTO'

const INITIAL_HOUR = '00:00'

export default {
  name: 'OpenHoursForm',
  components: {
    OpenHoursInput: () => import('./OpenHoursInput.vue'),
    CopyToAll: () => import('./CopyToAll.vue'),
    CopyToallConfirmationModal: () => import('./CopyToallConfirmationModal.vue')
  },
  props: {
    initialValues: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  data () {
    return {
      refFormOpenHours: FORM_CONTEXT_PHYSICAL_WORLD.FORM_OPEN_HOURS,
      currentDay: null,
      copyToAllModalVisible: false,
      formValid: false,
      form: this.openHoursInitialValues()
    }
  },

  watch: {
    form: {
      handler (value) {
        if (value.every(item => !item.open)) {
          this.$emit('update:formOpenHoursValid', false)
          return
        }

        this.$emit(
          'update:formOpenHoursValid',
          value.every(item => (item.open ? item.valid : true))
        )
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    showModal (item) {
      this.currentDay = item
      this.copyToAllModalVisible = true
    },
    handleClose () {
      this.copyToAllModalVisible = false
    },
    showCopy (item) {
      return item.open && !this.disabled
    },
    handleCopyAll (value) {
      const { start, end, open, valid } = value
      this.form = this.form.map(({ name }) => ({
        name,
        start,
        end,
        open,
        valid
      }))
      this.handleClose()
    },
    openHoursInitialValues () {
      return WEEKDAYS_LIST.map(name => {
        const value = this.initialValues?.[name]
        const startValue = value?.start || '00:00'
        const endValue = value?.end || '00:00'

        return {
          name,
          start: startValue,
          end: endValue,
          open: endValue !== INITIAL_HOUR,
          valid: false
        }
      })
    },
    isEveryDayInvalid () {
      return Object.entries(this.$refs).every(([key, item]) => {
        if (!WEEKDAYS_LIST.includes(key)) {
          return true
        }
        return item[0].$v.value.$invalid
      })
    },
    submitEmitter () {
      if (this.isEveryDayInvalid()) {
        return new PhysicalWorldFormDTO().setError(true)
      }

      const formattedData = this.form.reduce(
        (days, { name, start, end, open }) => {
          if (open) {
            days[name] = {
              start: `${start}:00`,
              end: `${end}:00`
            }
          }
          return days
        },
        {}
      )

      new PhysicalWorldFormDTO().addItem({
        open_hours: { days_of_the_week: formattedData }
      })
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Horário de funcionamento da loja",
      "description": "(Informe pelos um horário de atendimento)"
    },
    "en-US": {
      "title": "Store opening hours",
      "description": "(Provide open hours)"
    }
  }
</i18n>

<style scoped>
.open-hours__title {
  font-size: 14px;
  font-weight: var(--brand--btn--font-weight);
}
</style>
